<template lang="">
	<div id="content">
		<div class="global_area">
			<div class="path"><a href="#none">Home</a> &gt; <a href="#none">기타 관리</a> &gt; <strong>문의 내역 관리</strong></div>
			<h2 class="h_sub">팝업 리스트</h2>
		</div>

    <InquiryManageListForm/>
  </div>
</template>

<script>
import InquiryManageListForm from '@/components/admin/etc/InquiryManageListForm.vue';

export default {
  components: {
    InquiryManageListForm
  }    
}
</script>
<style lang="">
    
</style>